export default __webpack_public_path__ + "static/minidukan-icons-db8b682ebbee805a97990dab8b1f6a98.ttf";